import { render, staticRenderFns } from "./WeatherModule.vue?vue&type=template&id=510a04fc&scoped=true"
import script from "./WeatherModule.vue?vue&type=script&lang=js"
export * from "./WeatherModule.vue?vue&type=script&lang=js"
import style0 from "./WeatherModule.vue?vue&type=style&index=0&id=510a04fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510a04fc",
  null
  
)

export default component.exports